import { css } from "styled-components"
import * as flagIconsFontFace from "bnppf-flag-icons"

const flagIcons = css`
  ${flagIconsFontFace}
`

export default flagIcons
